// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__vs1yi","contact__content":"contact_contact__content__qE2rO","data":"contact_data__CpDZz"};